import request from '@/utils/request'
const BASE_URL = '/Work'

//工作
export default {
  //获取我的工作列表（包含表单项列表）
  getMyWorkWithFormList(data) {
    return request({
      url: BASE_URL + '/GetMyWorkWithFormList',
      method: 'post',
      data
    })
  },
}